// extracted by mini-css-extract-plugin
export default {"root":"PromoContainer_root__Z6dQy","container":"PromoContainer_container__Bbczu","content":"PromoContainer_content__IAuVw"};